import type { LevelNamingTemplate } from '@app/src/utils/assessmentLevelTranslations'
import { formatLevelLabel } from '@app/src/utils/assessmentLevelTranslations'
import { valueToLevelType } from '@app/src/utils/assessmentLevels'
import { Box, Chip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const getLevelChipPalette = (level: number, levelsCount: number): { bg: string; dot: string } => {
  switch (valueToLevelType(level, levelsCount)) {
    case 'veryPoor':
    case 'poor':
      return { bg: 'error.light', dot: 'error.dark' }
    case 'fair':
      return { bg: 'warning.light', dot: 'warning.dark' }
    default:
      return { bg: 'success.light', dot: 'success.dark' }
  }
}

const LevelChip: React.FC<{ level: number; assessmentTemplate?: LevelNamingTemplate }> = ({
  level,
  assessmentTemplate,
}) => {
  const { formatMessage } = useIntl()
  const { bg, dot } = getLevelChipPalette(level, assessmentTemplate?.levels ?? 5)
  return (
    <Chip
      size="medium"
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: dot }} />}
      label={formatLevelLabel(assessmentTemplate, level, formatMessage)}
      sx={{
        bgcolor: bg,
        color: 'text.primary',
        borderRadius: 4,
        px: 1,
      }}
    />
  )
}

export default LevelChip
